import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=18667923&scoped=true&"
import script from "./TaskSettings.vue?vue&type=script&lang=js&"
export * from "./TaskSettings.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=18667923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18667923",
  null
  
)

export default component.exports